module.exports = flarum.core.compat['extend'];